import api from './client';

// Phase 26 — broadcast a data-changed event whenever a live transitions
// between states (created/started/ended/cancelled/deleted). All listening
// pages (Home feed, Explore, Stories ring, Lives sidebar, Creator profile,
// Live Dashboard) refresh their view immediately without polling delay.
const _notify = () => {
  try { window.dispatchEvent(new Event('nymia:data-changed')); } catch (_e) { /* noop */ }
};

export const createLive = async (payload) => {
  const res = await api.post('/lives', payload);
  _notify();
  return res.data;
};

export const updateLive = async (id, payload) => {
  const res = await api.patch(`/lives/${id}`, payload);
  _notify();
  return res.data;
};

export const deleteLive = async (id) => {
  const res = await api.delete(`/lives/${id}`);
  _notify();
  return res.data;
};

// Phase 22 — lifecycle helpers
export const cancelLive = async (id) => {
  const res = await api.post(`/lives/${id}/cancel`);
  _notify();
  return res.data;
};

export const duplicateLive = async (id) => {
  const res = await api.post(`/lives/${id}/duplicate`);
  _notify();
  return res.data;
};

export const liveNow = async ({ kind = 'video', title = 'Live Now', description = '', category = '', privacy = 'public', video_format = '16:9', cover_url = '' } = {}) => {
  const res = await api.post('/lives/now', { kind, title, description, category, privacy, video_format, cover_url });
  _notify();
  return res.data;
};

// Phase 55 — standalone cover upload (returns { cover_url }).
export const uploadCoverImage = async (file) => {
  const fd = new FormData();
  fd.append('file', file);
  const res = await api.post('/lives/cover-upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  return res.data;
};

export const discoverLives = async () => {
  const res = await api.get('/lives/discover');
  return res.data;
};

export const livesByUser = async (username) => {
  const res = await api.get(`/lives/user/${username}`);
  return res.data;
};

// Phase 23.1 — Free booking ("Prenota") for free lives.
export const bookFreeLive = async (id) => {
  const res = await api.post(`/lives/${id}/book`);
  return res.data;
};

export const cancelFreeBooking = async (id) => {
  const res = await api.delete(`/lives/${id}/book`);
  return res.data;
};

export const getLive = async (id) => {
  const res = await api.get(`/lives/${id}`);
  return res.data;
};

export const startLive = async (id) => {
  const res = await api.post(`/lives/${id}/start`);
  _notify();
  return res.data;
};

export const endLive = async (id) => {
  const res = await api.post(`/lives/${id}/end`);
  _notify();
  return res.data;
};

// Phase 31 — Wallet-first ticket purchase. Replaces the legacy
// /lives/{id}/ticket/checkout (Stripe-direct) endpoint.
export const buyLiveTicket = async (id) => {
  const res = await api.post(`/lives/${id}/buy`);
  return res.data;
};

export const joinLive = async (id) => {
  const res = await api.post(`/lives/${id}/join`);
  return res.data;
};

export const leaveLive = async (id) => {
  await api.post(`/lives/${id}/leave`);
};

export const listViewers = async (id) => {
  const res = await api.get(`/lives/${id}/viewers`);
  return res.data;
};

export const inviteGuest = async (id, userId) => {
  const res = await api.post(`/lives/${id}/invite-guest`, { user_id: userId });
  return res.data;
};

export const respondInvite = async (id, accept) => {
  const res = await api.post(`/lives/${id}/respond-invite`, { accept });
  return res.data;
};

export const removeGuest = async (id, userId) => {
  const res = await api.post(`/lives/${id}/remove-guest`, { user_id: userId });
  return res.data;
};

// Phase 15 — viewer-initiated co-host requests
export const joinStage = async (id) => {
  const res = await api.post(`/lives/${id}/stage/join`);
  return res.data;
};

export const requestCohost = async (id, message = '') => {
  const res = await api.post(`/lives/${id}/request-cohost`, { message });
  return res.data;
};

export const cancelCohostRequest = async (id) => {
  const res = await api.post(`/lives/${id}/cancel-cohost-request`);
  return res.data;
};

export const respondCohostRequest = async (id, userId, accept) => {
  const res = await api.post(`/lives/${id}/respond-cohost-request`, { user_id: userId, accept });
  return res.data;
};
